import styled from 'styled-components'

export const TireSizeListWrapper = styled.div`
  margin-top: 5px;
`

export const Wrapper = styled.div`
  margin-bottom: 23px;
`
